import { ImageNumber } from './image2d/image_number';
import { Sprite } from './image2d/sprite';
import { Panel } from './image2d/panel';
import { Loop } from './animation/loop';

const elements = document.body.querySelectorAll('.mb-tdk');

function refresh(refreshElement: HTMLCanvasElement, pc: string, sp: string) {
  const media = window.matchMedia('screen and (max-width: 768px)');
  if (media.matches) {
    refreshElement.style.height = sp;
  } else {
    refreshElement.style.height = pc;
  }
}

elements.forEach(element => {
  const canvasElement = element.querySelector('.mb-tdk-display-content') as HTMLCanvasElement;
  const src = canvasElement.getAttribute('data-src') || '';
  const value = canvasElement.getAttribute('data-value');
  const result = canvasElement.getAttribute('data-result');
  const charWidth = Number(canvasElement.getAttribute('data-width'));
  const charHeight = Number(canvasElement.getAttribute('data-height'));
  const speedCoefficient = Number(canvasElement.getAttribute('data-speed'));
  const color = canvasElement.getAttribute('data-color') || 'rgba(0, 0, 255, 0)';
  const pcSize = canvasElement.getAttribute('data-pcsize') || '96px';
  const spSize = canvasElement.getAttribute('data-spsize') || '32px';
  const tdkEvent = canvasElement.getAttribute('data-event');
  const eventTime = Number(canvasElement.getAttribute('data-time')) * 60;

  let scrollPosition = 0;
  if (tdkEvent !== 'off') {
    canvasElement.classList.add('is-scroll');
    scrollPosition = (100 - Number(tdkEvent)) / 100;
  }

  if (!value || !result) {
    return;
  }

  // ループ回数
  let valueLength = value.length;
  let commaCount = Math.floor(valueLength / 3);
  if (!(valueLength % 3)) {
    commaCount--;
  }

  // imgクラス
  const numbersImage = new Image();
  numbersImage.src = src;

  numbersImage.onload = () => {
    // 背景色設定
    canvasElement.style.background = color;

    // PC・SPサイズ変更(レスポンシブ対応)
    refresh(canvasElement, pcSize, spSize);

    window.addEventListener('resize', () => {
      refresh(canvasElement, pcSize, spSize);
    });

    // 数値
    const numberImage = new ImageNumber(numbersImage, charWidth, charHeight);
    // コンマ
    const comma = new Sprite(numbersImage.width - charWidth * 10, charHeight);

    // canvasサイズ
    canvasElement.width = charWidth * valueLength + comma.width * commaCount;
    canvasElement.height = numbersImage.height;
    comma.context.drawImage(
      numbersImage,
      charWidth * 10,
      0,
      comma.width,
      comma.height,
      0,
      0,
      comma.width,
      comma.height,
    );

    // 出力用データ
    type viewData = { distance: number; y: number; value: number };
    const numbers: viewData[] = [];
    let targetFlag = false;
    for (let digit = 0; digit < value.length; digit++) {
      if (digit === value.length - 1) {
        targetFlag = true;
      }
      let number = {
        distance: 1,
        y: -numberImage.height,
        value: Number(value[digit]),
      };
      numbers.push(number);
    }

    const loop = new Loop({ targetFps: 60 });
    const context = canvasElement.getContext('2d');
    if (!context) {
      return;
    }

    const panel = new Panel(numberImage);

    let scrollFlag = false;
    let clickFlag = false;
    const speed = speedCoefficient * 10;
    let unsetNum = -(Number(result).toString().length - Number(value).toString().length);
    let scrollStop = false;
    const btn = element.querySelector('.mb-tdk-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        clickFlag = true;
      });
    }

    loop.queue(task => {
      if (tdkEvent !== 'off') {
        window.addEventListener('scroll', () => {
          const wiewElement = element.getBoundingClientRect();
          const outerHeight = window.outerHeight,
            point = wiewElement.top - outerHeight;
          if (point < -outerHeight * scrollPosition && point < -wiewElement.height && !scrollFlag) {
            scrollFlag = true;
            let timeCount = 0;
            for (let i = numbers.length - 1; i >= 0; i--) {
              task.onUpdate(() => {
                if (i === numbers.length - 1) {
                  timeCount++;
                }
                const delta = (Number(result[i]) - numbers[i].value) * charHeight - (charHeight + numbers[i].y);
                numbers[i].distance = ((delta + charHeight * 10) % charHeight) * 10;
                numbers[i].y += speed;
                if (numbers[i].y > 0) {
                  numbers[i].value = (numbers[i].value + 1) % 10;
                  const delta = numbers[i].y;
                  numbers[i].y = -numberImage.height + delta;
                }

                if ((timeCount > eventTime && eventTime) || clickFlag) {
                  let x = numbers.length - 1;
                  const digitChange = (x: number) => {
                    if (numbers[x].value === Number(result[x])) {
                      numbers[x].y = -numberImage.height;
                      if (x) {
                        x--;
                        digitChange(x);
                      }
                      scrollStop = true;
                    }
                  };
                  digitChange(x);
                }
              });
            }
          }
        });
      } else {
        if (!clickFlag) {
          const btn = element.querySelector('.mb-tdk-btn');
          if (btn) {
            btn.addEventListener('click', () => {
              clickFlag = true;
              let i = value.length - 1;
              task.onUpdate(() => {
                const delta = (Number(result[i]) - numbers[i].value) * charHeight - (charHeight + numbers[i].y);
                numbers[i].distance = ((delta + charHeight * 10) % charHeight) * 10;
                numbers[i].y += speed;
                if (numbers[i].y > 0) {
                  numbers[i].value = (numbers[i].value + 1) % 10;
                  const delta = numbers[i].y;
                  numbers[i].y = -numberImage.height + delta;
                }
                if (numbers[i].value === Number(result[i])) {
                  numbers[i].y = -numberImage.height;
                  if (i) {
                    i--;
                  }
                }
              });
            });
          }
        }
      }

      task.onDraw(() => {
        context.clearRect(0, 0, canvasElement.width, canvasElement.height);

        let commaViewCount = 0;
        for (let i = 0; i < numbers.length; i++) {
          panel.set(numbers[i].value);

          if (!((valueLength - i) % 3) && i > 0) {
            context.drawImage(comma.canvas, charWidth * i + comma.width * commaViewCount, 0, comma.width, comma.height);
            commaViewCount++;
          }

          context.drawImage(
            panel.canvas,
            charWidth * i + comma.width * commaViewCount,
            numbers[i].y,
            panel.width,
            panel.height,
          );
        }

        if ((clickFlag && unsetNum) || scrollStop) {
          let view = valueLength - unsetNum;
          let commaViewCount = 1;
          if (view > 3) {
            commaViewCount = comma.width * commaViewCount;
          }
          context.clearRect(0, 0, canvasElement.width - view * charWidth - commaViewCount, canvasElement.height);
        }
      });
    });

    loop.run();
  };
});
